import script from "./PaySteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaySteps.vue?vue&type=script&setup=true&lang=ts"

import "./PaySteps.vue?vue&type=style&index=0&id=2b0abdeb&lang=css"

const __exports__ = script;

export default __exports__